import { TeamMember } from '../admin/admin.types';
import { PaginationMeta, PaginationParams } from '../pagination/pagination.types';
import { WebhookEvent } from './webhooks.enums';

export type WebhookConfig = {
  id: number;
  name: string;
  url: string;
  eventSubscription: WebhookEventSubscription;
};
export enum WebhookConfigDeliveryKind {
  Success = 'success',
  SomeFailed = 'some_failed',
  AllFailed = 'all_failed',
}
export type WebhookConfigDelivery =
  | { kind: WebhookConfigDeliveryKind.Success }
  | { kind: WebhookConfigDeliveryKind.SomeFailed; count: number }
  | { kind: WebhookConfigDeliveryKind.AllFailed };

export type WebhookEventSubscription = { eventType: WebhookEvent; subscription: boolean }[];

export type WebhookConfigCreateParams = Pick<WebhookConfig, 'name' | 'url' | 'eventSubscription'>;
export type WebhookConfigUpdateParams = Partial<Pick<WebhookConfig, 'name' | 'eventSubscription'>>;

export type WebhookSecret = {
  id: number;
  partialValue: string;
};

export type WebhookRequest = {
  id: number;
  eventType: WebhookEvent;
  requestBody: string;
  attemptCount: number;
  nextAttemptAt: string | null;
  lastAttemptAt: string | null;
  lastResponseStatus: string | null;
  lastResponseBody: string | null;
  lastResponseError: string | null;
  createdAt: string;
  config?: WebhookConfig;
};

export type PaginatedWebhookRequests = {
  meta: PaginationMeta;
  requests: WebhookRequest[];
};

export type WebhookRequestParams = PaginationParams & {
  configId?: string | null;
};

export type WebhookCompanyConfig = {
  emailRecipients: TeamMember[];
};

export type WebhookCompanyConfigParams = {
  emailRecipientIds: number[];
};
